// extracted by mini-css-extract-plugin
export default {"container":"Root_container__2MkRT"};